module.exports = __webpack_public_path__ + "2f93bcdccda740d2dc1901151992ab26.MP3";